import { Controller } from "@hotwired/stimulus";

// Pré-remplit le scan d'une entreprise depuis un SIRET (base Sirene de l'INSEE).
//
// Déclenché dès que le champ SIREN / SIRET contient 14 chiffres. Les champs
// remplis restent modifiables : c'est une saisie assistée, pas un verrou. Le
// représentant légal n'est pas dans Sirene, il reste à saisir.
export default class extends Controller {
  static targets = ["siret", "legalName", "tradeName", "country", "status"];
  static values = { url: String, searching: String, found: String };

  connect() {
    this.hint = this.statusTarget.textContent;
  }

  async lookup() {
    const siret = this.siretTarget.value.replace(/\s+/g, "");
    if (!/^\d{14}$/.test(siret)) {
      this.#status(this.hint);
      return;
    }
    if (siret === this.lastSiret) return;
    this.lastSiret = siret;

    this.#status(this.searchingValue);
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("siret", siret);

    let body;
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } });
      body = await response.json();
      // Une réponse arrivée après une nouvelle frappe ne doit pas écraser la saisie.
      if (siret !== this.lastSiret) return;
      if (!response.ok) {
        this.lastSiret = null;
        this.#status(body.error, true);
        return;
      }
    } catch {
      this.lastSiret = null;
      this.#status(this.hint);
      return;
    }

    this.#fill(this.legalNameTarget, body.legal_name);
    this.#fill(this.tradeNameTarget, body.trade_name);
    this.#fill(this.countryTarget, body.registration_country);
    this.#status(this.foundValue.replace("%{name}", body.legal_name || siret));
  }

  #fill(field, value) {
    if (!value) return;

    field.value = value;
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  #status(text, error = false) {
    this.statusTarget.textContent = text;
    this.statusTarget.classList.toggle("text-danger", error);
    this.statusTarget.classList.toggle("text-muted", !error);
  }
}
